var WooShipping = {

	init:function(){
		
				
		$(".wc_payment_method.payment_method_stripe").find(".payment_box.payment_method_stripe").css({height:$("#stripe-payment-data p").height()});

		$("#customer_details").find("input").on("change", function(){

			Debug.log("INPUT HAS CHANGED");
			$("#customer_details").removeClass("valid");
			WooShipping.check_required();

			$(".shipping-method-container").css({height:0});
		});

		WooShipping.check_required();

		$(document).on('updated_checkout', function(){
			WooShipping.change_shipping_method();
			if($('#customer_details').hasClass('valid')){
				WooShipping.show_shipping();
			}else{
				$(".shipping-method-container").css({height:0});
			}
		});

		$(document).on("click touchend", ".woocommerce-NoticeGroup .btn-close", function(e){
			if(e.type == "touchend"){
				$(this).off("click");
			}
			$(".woocommerce-NoticeGroup").remove();
		})

		$(".shippping-to-different-adress select").change(function(){
			$('#ship-to-different-address-checkbox').click();			

			$("#customer_details").removeClass("valid");

			setTimeout(function(){				
				WooShipping.check_required();
			}, 40);
		});

		$(".createaccount select").change(function(){
			console.log('select change');
			$('#createaccount').click();
		});

		$(".btn.validate-coord").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			$('#customer_details').addClass('valid');
			WooShipping.show_shipping();

		});
		$(document).on("click touchend", ".btn.validate-shipping", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			WooShipping.show_paiement();

		});

		$(document).on("click touchend", ".shipping-item", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}
			var $radios = $('input:radio[name=shipping_method]');
			if($radios.is(':checked') === false) {
				$(this).find('input').prop('checked', true);
				$(this).find('input').trigger('change');
			}
		});
		$(document).on("change", ".shipping-item input", function(){
			WooShipping.change_shipping_method();
		});

		$(document).on("click touchend", ".wc_payment_method", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}

			$(this).find("input.input-radio").click();
		});

		$(document).on("change", ".wc_payment_method input.input-radio", function(){
			WooShipping.change_payment_method();
		});



		WooShipping.change_shipping_method();
		WooShipping.change_payment_method();


		$(".shipping-method-container").css({height:0});
	},
	change_shipping_method:function(){

		Debug.log("CHANGE SHIPPING METHOD");

		$("#shipping_method li").each(function(){
			var _li = $(this);

			if($(this).find("input").is(":checked")){
				_li.addClass("selected");
			}else{
				_li.removeClass("selected");
			}
		})
	},
	change_payment_method:function(){
		
		$(".wc_payment_method").each(function(){
			var _li = $(this);

			if($(this).find("input[type='radio']").is(":checked")){
				_li.addClass("selected");
				
				if(_li.hasClass("payment_method_stripe")){
					Debug.log("IS STRIPE : OPEN");
					var _h_dest = $("#stripe-payment-data").height();					
					_li.find(".payment_box.payment_method_stripe").css({height:_h_dest});
				}
				
				
			}else{
				_li.removeClass("selected");
				
				
				if(_li.hasClass("payment_method_stripe")){
					Debug.log("IS STRIPE : CLOSE");
					var _h_dest = $("#stripe-payment-data p").height();
					_li.find(".payment_box.payment_method_stripe").css({height:_h_dest});
				}
				
			}
		});
		
		
	},
	show_shipping:function(){

		var _scroll_dest = $(".woocommerce-shipping-totals").offset().top - 100;

		$("html, body").animate({scrollTop:_scroll_dest}, 400);

		var _h_dest = $(".shipping-method-content").height();

		$(".shipping-method-container").css({height:_h_dest});
	},
	show_paiement:function(){
		var _scroll_dest = $(".woocommerce-checkout-payment").offset().top - 100;

		$("html, body").animate({scrollTop:_scroll_dest}, 400);

		var _h_dest = $(".payment-content").height();
		Debug.log("SHOW PAYMENT : " + _h_dest);
		$(".payment-container").css({height:_h_dest});
	},
	check_required:function(){

		var _retour = true;

		$(".woocommerce-billing-fields__field-wrapper").find("input[required]").each(function(){

			if(($(this).val() == "")||($(this).val() == undefined)){
				_retour = false;
			}
		});

		if($(".shipping_address").css('display') != 'none'){
			$(".shipping_address").find("input[required]").each(function(){

				if(($(this).val() == "")||($(this).val() == undefined)){
					_retour = false;
				}
			});
		}


		if(_retour == false){
			$(".validate-coord").addClass("inactive");
		}else{
			$(".validate-coord").removeClass("inactive");
		}

		return _retour;
	}
}

$(window).load(function(){
	if($(".shippping-to-different-adress").length){
		WooShipping.init();
	}
});